export default __webpack_public_path__ + "static/texture-709a51b8c2a22c4422d752590796b1be.jpg";